import { Injectable, inject } from '@angular/core';
import { Database, get, objectVal, ref, set, update } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject, map } from 'rxjs';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private database: Database = inject(Database);
  temasMenu: boolean = false;
  listenerMenu = new Subject();

  changeTemaMenu(status: boolean) {
    this.listenerMenu.next(status);
  }
  
  get listenerMenu$ () {
    return this.listenerMenu.asObservable();
  }

  getReferenciaUsuario (uid:string) {
    const referenciaUsuario = ref(this.database, `usuarios/${uid}`);
    return referenciaUsuario;
  }

  setUsuarioMigrado (userID: string) {
    const refUrlBack = ref(this.database, `migracion/url_back`);
    const refUsuarioMigrado = ref(this.database, `migracion/usuarios/${userID}`);
    
    set(refUsuarioMigrado, 1).then(() => {
      console.log('cambio completado');

      get(refUrlBack).then((snapshot) => {
        if (snapshot.exists()) {
          window.location.href = snapshot.val();
        }
      }).catch((error) => {
        console.error(error);
      });

    }).catch((error) => {
      console.log(error);
    });
  }
}